module.exports = __webpack_public_path__ + "static/img/default.862c7ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default.png
// module id = 14
// module chunks = 1